<template>
  <div class="profile-container">
    <!-- 头部区域 -->
    <header class="profile-header">
      <div class="avatar-wrapper" @click="handleAvatarClick">
        <el-avatar 
          :size="mobile ? 72 : 96" 
          :src="user.avatarUrl"
          class="avatar"
        >
          <template #default>
            <Camera class="camera-icon" />
          </template>
        </el-avatar>
      </div>
      <h1 class="username">{{ user.name }}</h1>
      <div class="tags">
        <span 
          v-for="(tag, index) in user.tags" 
          :key="index" 
          class="tag"
          :style="{ backgroundColor: tagColors[index] }"
        >
          {{ tag }}
        </span>
      </div>
    </header>

    <!-- 功能入口 -->
    <section class="function-section">
      <div class="grid-container">
        <div 
          v-for="(item, index) in functionItems" 
          :key="item.title"
          class="grid-item"
          @click="navigate(item.link)"
          :style="{ '--hover-color': itemColors[index] }"
        >
          <component :is="item.icon" class="item-icon" />
          <span class="item-title">{{ item.title }}</span>
        </div>
      </div>
    </section>

    <!-- 设置列表 -->
    <section class="settings-section">
      <div 
        v-for="setting in settings" 
        :key="setting.title"
        class="setting-item"
        @click="handleSettingClick(setting)"
      >
        <div class="setting-left">
          <component :is="setting.icon" class="setting-icon" />
          <div class="setting-info">
            <h3 class="setting-title">{{ setting.title }}</h3>
            <p class="setting-desc">{{ setting.description }}</p>
          </div>
        </div>
        <ArrowRight class="arrow-icon" />
      </div>
    </section>


    <HouseBottom/>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount,getCurrentInstance } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage } from "element-plus";
import { 
  User,
  Edit,
  Bell,
  Message,
  Setting,
  SwitchButton,
  Camera,
  ArrowRight
} from "@element-plus/icons-vue";
import HouseBottom from "@/views/house/bottom/houseBottom.vue";

const { proxy } = getCurrentInstance();
const router = useRouter()
const mobile = ref(false)
const isAdmin = ref('0');

// 用户信息
const user = ref({
  name: '',
  avatarUrl: 'https://picsum.photos/200',
  // avatarUrl: '@/assets/logo.png',
  tags: ['vip', '资深']
})


// 功能入口配置
const functionItems = [
  { title: '我的收藏', icon: User, link: '/myLike' },
  { title: '项目管理', icon: Edit, link: '/houseCustomerService' },
 { title: '通知消息', icon: Bell, link: '/houseCustomerService' },
  { title: '联系客服', icon: Message, link: '/houseCustomerService' },
]

// 设置项配置
const settings = [
  // { title: '账号设置', description: '个人信息与安全设置', icon: Setting, link: '/houseCustomerService', actionType: 'navigate' },
  { title: '修改密码', description: '修改账户密码', icon: Setting, link: '/updatePwd', actionType: 'navigate' },
  { title: '关于我们', description: '版本信息与服务条款', icon: User, link: '/aboutOur', actionType: 'navigate' },
  { title: '退出登录', description: '安全退出当前的账号', icon: SwitchButton, link: '/', actionType: 'api', apiMethod: 'logout' },
];

// 颜色配置
const tagColors = ['#ffedd5', '#dcfce7']
const itemColors = ['#60a5fa', '#4ade80', '#fbbf24', '#f472b6']

// 响应式检测
const checkMobile = () => {
  mobile.value = window.innerWidth < 768
}

// 路由跳转
const navigate = (link) => {
  router.push(link)
}

// 头像点击处理
const handleAvatarClick = () => {
  // 实现头像上传逻辑
}

const checkRule = async () => {
  const url = '/login/checkRule';
  try {
    const response = await proxy.$tools.request(url, { reqBody: {} });
    if ('00000000' === response.data.rspHead.returnCode) {
      isAdmin.value = response.data.rspBody.isAdmin;
      user.value.name = response.data.rspBody.userName;
    } else {
      ElMessage.error('系统异常，请联系管理员');
    }
  } catch (error) {
    ElMessage.error('系统异常，请联系管理员', error);
  }
};


const checkLogin = () => {
      let token = localStorage.getItem("token"); // 从缓存中获取token
        token = token || null;
      if (token) {
        // 如果有token，调用后端接口验证
        const url = "/login/checkLoginStatus";
        proxy.$tools
          .request(url, { reqBody: {} })
          .then((response) => {
            const returnCode = response.data.rspHead.reurnCode;
            if (!"000000" === returnCode) {
              router.push("/error");
            }
            const status = response.data.rspBody.status;
            if ("0" === status) {
              router.push("/appLogin");
            } 
          })
          .catch((error) => {
            // 处理错误情况
            console.error(error);
          });
      } else {
        // 如果没有token，重定向到登录页面
        router.push("/appLogin");
      }
    };

    const handleSettingClick = (setting) => {
      if (setting.actionType === 'navigate') {
      navigate(setting.link);
    } else if (setting.actionType === 'api') {
      callApiForSetting(setting.apiMethod);
    }
  };

  const callApiForSetting = async (method) => {
  try {
    switch (method) {
      case 'logout':
        // 如果有token，调用后端接口验证
        proxy.$tools
          .request('/login/logoff', { reqBody: {isUserLogoff:'1'} })
          .then((response) => {
            // console.log('返回'+JSON.stringify(response.data))
            const returnCode = response.data.rspHead.returnCode;
            if ('00000000' === returnCode) {
              //清除token
              // let token = localStorage.getItem("token"); 
              localStorage.removeItem(localStorage.getItem("token"));
              ElMessage.success('操作成功');
              router.push("/appLogin");
            }else{
              ElMessage.success('操作成功');
              router.push("/appLogin");
              // router.push("/error");
            }
          })
          .catch((error) => {
            // 处理错误情况
            console.error(error);
          });
        // response = await proxy.$tools.request('/api/logout', {});
        break;
      // 其他API
    }
    
  } catch (error) {
    ElMessage.error('请求异常');
  }
};


// 生命周期钩子
onMounted(() => {
  checkLogin();
  checkMobile();
  checkRule();
  window.addEventListener('resize', checkMobile)
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', checkMobile)
})
</script>

<style scoped>
/* 基础样式 */
:root {
  --primary-color: #60a5fa;
  --bg-color: #f8fafc;
  --card-radius: 1rem;
  --transition-speed: 0.3s;
}

.profile-container {
  max-width: 768px;
  margin: 0 auto;
  padding: 1rem;
  background: var(--bg-color);
  min-height: 100vh;
}

/* 头部样式 */
.profile-header {
  text-align: center;
  padding: 2rem 0;
  position: relative;
}

.avatar-wrapper {
  display: inline-block;
  position: relative;
  border-radius: 50%;
  padding: 4px;
  background: linear-gradient(45deg, #60a5fa, #4ade80);
}

.avatar {
  border: 3px solid white;
  transition: transform var(--transition-speed);
}

.avatar:hover {
  transform: scale(1.05);
}

.camera-icon {
  width: 24px;
  height: 24px;
  color: white;
  background: rgba(0,0,0,0.5);
  padding: 4px;
  border-radius: 50%;
}

.username {
  margin: 1rem 0 0.5rem;
  font-size: 1.5rem;
  color: #1e293b;
  font-weight: 600;
}

.tags {
  display: flex;
  gap: 0.5rem;
  justify-content: center;
}

.tag {
  padding: 0.25rem 0.75rem;
  border-radius: 1rem;
  font-size: 0.875rem;
  font-weight: 500;
}

/* 功能入口 */
.function-section {
  margin: 1.5rem 0;
}

.grid-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 1rem;
  padding: 0 1rem;
}

.grid-item {
  background: white;
  border-radius: var(--card-radius);
  padding: 1.5rem;
  text-align: center;
  cursor: pointer;
  transition: all var(--transition-speed);
  position: relative;
  overflow: hidden;
}

.grid-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: var(--hover-color);
  opacity: 0;
  transition: opacity var(--transition-speed);
}

.grid-item:hover::before {
  opacity: 0.1;
}

.item-icon {
  width: 2.5rem;
  height: 2.5rem;
  color: var(--hover-color);
  margin-bottom: 0.75rem;
}

.item-title {
  font-weight: 500;
  color: #1e293b;
}

/* 设置项 */
.settings-section {
  background: white;
  border-radius: var(--card-radius);
  margin: 1.5rem 0;
  padding: 0 1rem;
  padding-bottom: calc(72px + env(safe-area-inset-bottom)); /* 动态计算安全区域 */
}

.setting-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 0;
  border-bottom: 1px solid #e2e8f0;
  cursor: pointer;
  transition: background-color var(--transition-speed);
}

.setting-item:last-child {
  border-bottom: none;
}

.setting-item:hover {
  background-color: #f8fafc;
}

.setting-left {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.setting-icon {
  width: 1.5rem;
  height: 1.5rem;
  color: #64748b;
  padding: 0.5rem;
  background: #f1f5f9;
  border-radius: 0.75rem;
}

.setting-title {
  font-weight: 500;
  color: #1e293b;
  margin-bottom: 0.25rem;
}

.setting-desc {
  font-size: 0.875rem;
  color: #64748b;
}

.arrow-icon {
  width: 1.25rem;
  height: 1.25rem;
  color: #94a3b8;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .profile-container {
    padding: 0.5rem;
  }

  .grid-container {
    grid-template-columns: repeat(2, 1fr);
    gap: 0.5rem;
  }

  .grid-item {
    padding: 1rem;
  }

  .setting-item {
    padding: 0.75rem 0;
  }
}

@media (max-width: 480px) {
  .username {
    font-size: 1.25rem;
  }

  .item-icon {
    width: 2rem;
    height: 2rem;
  }

  .item-title {
    font-size: 0.875rem;
  }
}

</style>
